import React from 'react';
import SidebarLayout from '../components/Layout/SidebarLayout';
import UserPro from '../components/Profile/UserPro';

const Profile = () => {
  return (
    <SidebarLayout>
    
  <UserPro />
    </SidebarLayout>
  );
};

export default Profile;